"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectAmount = void 0;
const vue_1 = require("vue");
const Button_1 = require("../components/common/Button");
const TranslateMixin_1 = require("./TranslateMixin");
exports.SelectAmount = vue_1.default.component('select-amount', {
    components: {
        'Button': Button_1.Button,
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    props: {
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        return {
            amount: this.playerinput.maxByDefault ? String(this.playerinput.max) : String(this.playerinput.min),
        };
    },
    methods: {
        saveData: function () {
            this.onsave([[String(parseInt(this.amount))]]);
        },
        setMaxValue: function () {
            this.amount = String(this.playerinput.max);
        },
    },
    template: `
    <div>
        <div v-if="showtitle === true">{{ $t(playerinput.title) }}</div>
        <div class="flex">
            <input type="number" class="nes-input" value="playerinput.min" :min="playerinput.min" :max="playerinput.max" v-model="amount" />
            <Button size="big" type="max" :onClick="setMaxValue" title="MAX" />
            <Button v-if="showsave === true" size="big" :onClick="saveData" :title="playerinput.buttonLabel" />
        </div>
    </div>`,
});
//# sourceMappingURL=SelectAmount.js.map